var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-table', {
    staticClass: "table-outline mb-0",
    attrs: {
      "hover": "hover",
      "responsive": "responsive",
      "outline": "outline",
      "head-variant": "default",
      "items": _vm.data,
      "fields": _vm.label,
      "small": _vm.small,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc
    },
    on: {
      "row-clicked": _vm.ping,
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "avatar",
      fn: function(item) {
        return [_c('div', {
          staticClass: "avatar"
        }, [(item.value.tooltip) ? _c('img', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            value: (_vm.userIdString(item.value.tooltip)),
            expression: "userIdString(item.value.tooltip)",
            modifiers: {
              "hover": true
            }
          }],
          staticClass: "img-avatar",
          attrs: {
            "src": item.value.url || "static/img/avatars/0.png",
            "alt": ""
          }
        }) : _vm._e(), (item.value.status) ? _c('span', {
          staticClass: "avatar-status",
          class: item.value.status ? "bg-" + item.value.status : "bg-danger"
        }) : _vm._e(), (item.value.platform) ? _c('span', {
          staticClass: "avatar-platform fa",
          class: [item.value.platform == "fb" && "fa-facebook-official", item.value.platform == "whatsapp" && "fa-whatsapp", item.value.platform != "whatsapp" && item.value.platform != "fb" && "fa-globe"]
        }) : _vm._e()])]
      }
    }, {
      key: "messageId",
      fn: function(item) {
        return [_vm._v(_vm._s(item.value))]
      }
    }, {
      key: "message",
      fn: function(item) {
        return [_c('div', [_vm._v(_vm._s(item.value))])]
      }
    }, {
      key: "flagHandleBy",
      fn: function(item) {
        return [_c('b-form', {
          attrs: {
            "inline": "inline"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
            },
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('b-input-group', [_c('b-form-input', {
          staticClass: "table-flaghandle",
          attrs: {
            "value": item.value.flagHandleBy[0],
            "readonly": "readonly"
          }
        }), _c('b-input-group-button', {
          slot: "right"
        }, [_c('b-btn', {
          attrs: {
            "variant": "outline-primary",
            "id": "flagHandleBy" + item.value.id
          }
        }, [_c('i', {
          staticClass: "fa fa-caret-left"
        })])], 1)], 1)], 1), _c('b-popover', {
          ref: "popover",
          attrs: {
            "target": "flagHandleBy" + item.value.id,
            "placement": "left",
            "triggers": "click"
          }
        }, [_vm._v(_vm._s(item.value.flagHandleByString))])]
      }
    }, {
      key: "firstInteraction",
      fn: function(item) {
        return [(item.value != null && item.value != "" && item.value != "-") ? _c('span', [_vm._v(_vm._s(_vm._f("moment")(item.value, 'from', 'now')))]) : _c('span', [_vm._v("Invalid Date")])]
      }
    }, {
      key: "numTimestamp",
      fn: function(item) {
        return [(item.value != null && item.value != "" && item.value != "-") ? _c('span', [_vm._v(_vm._s(_vm._f("moment")(item.value, 'from', 'now')))]) : _c('span', [_vm._v("Invalid Date")])]
      }
    }, {
      key: "agent",
      fn: function(item) {
        return [_c('div', {
          staticClass: "avatar"
        }, [_c('img', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.right",
            value: (_vm.userIdString(item.value.tooltip)),
            expression: "userIdString(item.value.tooltip)",
            modifiers: {
              "hover": true,
              "right": true
            }
          }],
          staticClass: "img-avatar",
          attrs: {
            "src": item.value.url,
            "alt": ""
          }
        })])]
      }
    }, {
      key: "sentiment",
      fn: function(item) {
        return [(item.value && item.value.number >= 0) ? _c('button', {
          staticClass: "btn btn-success"
        }, [_vm._v(_vm._s(item.value.score) + "  "), _c('span', {
          staticClass: "fa fa-thumbs-o-up"
        })]) : (item.value && item.value.number < 0) ? _c('button', {
          staticClass: "btn btn-danger"
        }, [_vm._v(_vm._s(item.value.score) + "  "), _c('span', {
          staticClass: "fa fa-thumbs-o-down"
        })]) : _c('button', {
          staticClass: "btn btn-secondary"
        }, [_vm._v("-")])]
      }
    }])
  })
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-695ab55e","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/InteractionsTable.vue
// module id = 1544
// module chunks = 1